import { Box, Text, Heading, Container } from "@chakra-ui/react";

const AvisoPrivacidad = () => {
  return (
    <Container maxW="container.lg" py={10}>
      <Heading as="h1" size="xl" mb={6} textAlign="center">
        AVISO DE PRIVACIDAD
      </Heading>
      <Heading as="h2" size="lg" mb={4}>
        PORTAL DE PAGOS DE TOTOLAC
      </Heading>
      <Text mb={4}>
        El H. Ayuntamiento de Totolac, en cumplimiento con la normativa vigente
        en materia de protección de datos personales, pone a disposición de los
        usuarios del portal de pagos en línea portalpagos.totolac.gob.mx el
        presente Aviso de Privacidad, con el objetivo de informar sobre el
        tratamiento de los datos personales recabados a través de este sitio web.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Responsable del tratamiento de datos personales
      </Heading>
      <Text mb={4}>
        El H. Ayuntamiento de Totolac, con domicilio en Tepetlapa y Nieves, 90160
        San Juan Totolac, Tlax, es responsable del tratamiento de los datos
        personales recabados a través del portal de pagos.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Datos personales que se recaban
      </Heading>
      <Text mb={4}>
        Los datos personales solicitados incluyen:
      </Text>
      <Box as="ul" pl={5} mb={4}>
        <Box as="li">Nombre completo del usuario</Box>
        <Box as="li">Clave Catastral, número de toma de agua o referencia de pago</Box>
        <Box as="li">Correo electrónico</Box>
        <Box as="li">Datos de contacto (teléfono, correo electrónico y domicilio)</Box>
        <Box as="li">Información fiscal para facturación (RFC, razón social, domicilio fiscal)</Box>
      </Box>
      <Text mb={4}>
        El portal de pagos no almacena datos bancarios, números de tarjeta de
        crédito o débito, ni información confidencial relacionada con métodos de
        pago.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Finalidad del tratamiento de datos personales
      </Heading>
      <Text mb={4}>
        Los datos personales recabados serán utilizados para gestionar pagos,
        generar comprobantes, verificar identidad, brindar atención y cumplir
        obligaciones legales y fiscales.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Transferencia de datos personales
      </Heading>
      <Text mb={4}>
        Los datos personales no serán compartidos con terceros, salvo en casos
        establecidos por la ley o con la pasarela de pago Openpay para la
        validación y procesamiento de pagos.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Medidas de seguridad
      </Heading>
      <Text mb={4}>
        Se implementan medidas de seguridad para proteger los datos personales,
        aunque el usuario reconoce que la transmisión de información en internet
        no es completamente segura.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Derechos ARCO
      </Heading>
      <Text mb={4}>
        El usuario puede ejercer sus derechos de Acceso, Rectificación,
        Cancelación y Oposición presentando una solicitud en las oficinas del
        Ayuntamiento o a través de los canales oficiales.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Modificaciones al aviso de privacidad
      </Heading>
      <Text mb={4}>
        Este Aviso de Privacidad puede ser modificado en cualquier momento y las
        actualizaciones serán publicadas en el portal de pagos.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Contacto
      </Heading>
      <Text mb={4}>
        Para dudas o solicitudes sobre el tratamiento de datos personales,
        comuníquese a:
      </Text>
      <Box>
        <Text><strong>Teléfono:</strong> 246 328 0933</Text>
        <Text><strong>Correo electrónico:</strong> ayuntamientototolacdigital@gmail.com</Text>
        <Text><strong>Domicilio:</strong> Tepetlapa y Nieves, 90160 San Juan Totolac, Tlax.</Text>
      </Box>
      <Text fontSize="sm" color="gray.500" mt={4}>
        Fecha de última actualización: 11 de marzo 2025
      </Text>
    </Container>
  );
};

export default AvisoPrivacidad;